export default {
  SET_CONFIGS(state, users) {
    state.configs = users
  },
  SET_CONFIGS_COUNT(state, count) {
    state.configsCount = count
  },
  SET_CONFIGS_QUERY(state, query) {
    state.query = query
  },
  SET_CONFIGS_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_CONFIGS_SKIP(state, skip) {
    state.skip = skip
  },
  SET_GENERAL_CONFIGS(state, data) {
    state.placeCategorySubject = data.filter(i => i.key === 'Place:Category:Subject').map(i => i.value)[0]
    state.availableProvinces = data.filter(i => i.key === 'AvailableProvinces').map(i => i.value)[0]
    state.placeSubjectServiceDetail = data
      .filter(i => i.key === 'Place:Subject:Service:Detail')
      .map(i => {
        const province = i.groups.find(g => g.startsWith('province:')).substring(9)

        return [province, i.value]
      })
      .reduce((acc, curr) => ((acc[curr[0]] = curr[1]), acc), {})
  }
}
